import { render } from "./KontaktArtikle.vue?vue&type=template&id=5f6cfc43"
import script from "./KontaktArtikle.vue?vue&type=script&lang=js"
export * from "./KontaktArtikle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__